import React from "react";
import Eligibility from "./Eligibility/Eligibility.jsx";
import LoanEstimator from "./Estimator/LoanEstimator.jsx";
import Tailor from "./Tailor/Tailor.jsx";
import Insights from "./Insights/Insights.jsx";
import { Helmet } from "react-helmet-async";

const LAPDashboardPage = () => {
  return (
    <>
      <Helmet>
        <title>Loan Against Property Dashboard - Minemi</title>{" "}
      </Helmet>
      <Eligibility />
      <LoanEstimator />
      <Tailor />
      <Insights />
    </>
  );
};

export default LAPDashboardPage;
